import { featureItems } from '@/mocks/home';

export default function Features() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-900">
            平台优势
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            为什么数百万读者选择51黑料网作为他们的娱乐资讯首选平台
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {featureItems.map((item, idx) => (
            <div
              key={item.id}
              className="relative text-center p-6 md:p-8 rounded-2xl bg-background-50 border border-background-200/70 transition-all duration-300 hover:border-primary-200 cursor-pointer group"
            >
              <div className={`w-16 h-16 md:w-18 md:h-18 mx-auto flex items-center justify-center rounded-2xl ${
                idx === 0
                  ? 'bg-primary-500 text-white'
                  : idx === 1
                  ? 'bg-accent-500 text-white'
                  : 'bg-secondary-500 text-white'
              }`}>
                <i className={`${item.icon} text-2xl md:text-3xl`}></i>
              </div>
              <h3 className="mt-5 md:mt-6 font-heading font-bold text-lg md:text-xl text-foreground-900">
                {item.title}
              </h3>
              <p className="mt-3 text-sm md:text-base text-foreground-600 leading-relaxed">
                {item.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}